const currencySymbols = {
    'USD': '$',
    'EUR': '€',
    'GBP': '£',
    'JPY': '¥',
    'CHF': 'CHF ',
    'CAD': 'C$',
    'AUD': 'A$',
    'NZD': 'NZ$',
    'CNY': '¥',
    'HKD': 'HK$',
    'SGD': 'S$',
    'KRW': '₩',
    'SEK': 'kr',
    'NOK': 'kr',
    'DKK': 'kr',
    'PLN': 'zł',
    'CZK': 'Kč',
    'HUF': 'Ft',
    'RON': 'lei',
    'BGN': 'лв',
    'HRK': 'kn',
    'RUB': '₽',
    'UAH': '₴',
    'BYN': 'Br',
    'TRY': '₺',
    'ILS': '₪',
    'SAR': '﷼',
    'AED': 'د.إ',
    'QAR': '﷼',
    'KWD': 'د.ك',
    'BHD': '.د.ب',
    'OMR': '﷼',
    'JOD': 'د.ا',
    'LBP': '£',
    'EGP': '£',
    'INR': '₹',
    'PKR': '₨',
    'BDT': '৳',
    'LKR': '₨',
    'NPR': '₨',
    'BTN': 'Nu.',
    'MVR': '.ރ',
    'AFN': '؋',
    'THB': '฿',
    'VND': '₫',
    'LAK': '₭',
    'KHR': '៛',
    'MMK': 'Ks',
    'BND': 'B$',
    'MYR': 'RM',
    'IDR': 'Rp',
    'PHP': '₱',
    'TWD': 'NT$',
    'MOP': 'MOP$',
    'KZT': '₸',
    'UZS': 'лв',
    'KGS': 'лв',
    'TJS': 'SM',
    'TMT': 'T',
    'AZN': '₼',
    'GEL': '₾',
    'AMD': '֏',
    'IRR': '﷼',
    'IQD': 'ع.د',
    'ZAR': 'R',
    'NAD': 'N$',
    'BWP': 'P',
    'SZL': 'E',
    'LSL': 'M',
    'KES': 'KSh',
    'UGX': 'USh',
    'TZS': 'TSh',
    'RWF': 'RF',
    'BIF': 'FBu',
    'ETB': 'Br',
    'DJF': 'Fdj',
    'SOS': 'S',
    'NGN': '₦',
    'GHS': '₵',
    'XOF': 'CFA',
    'XAF': 'FCFA',
    'MAD': 'د.م.',
    'DZD': 'د.ج',
    'TND': 'د.ت',
    'LYD': 'ل.د',
    'SDG': 'ج.س.',
    'SSD': '£',
    'ERN': 'Nfk',
    'MZN': 'MT',
    'ZMW': 'ZK',
    'MWK': 'MK',
    'ZWL': 'Z$',
    'AOA': 'Kz',
    'CVE': '$',
    'GMD': 'D',
    'GNF': 'FG',
    'LRD': 'L$',
    'SLE': 'Le',
    'MRU': 'UM',
    'STN': 'Db',
    'CDF': 'FC',
    'XPF': '₣',
    'BRL': 'R$',
    'ARS': '$',
    'CLP': '$',
    'COP': '$',
    'PEN': 'S/',
    'BOB': 'Bs.',
    'PYG': '₲',
    'UYU': '$U',
    'VES': 'Bs.S',
    'GYD': 'G$',
    'SRD': '$',
    'MXN': '$',
    'GTQ': 'Q',
    'BZD': 'BZ$',
    'SVC': '$',
    'HNL': 'L',
    'NIO': 'C$',
    'CRC': '₡',
    'PAB': 'B/.',
    'CUP': '₱',
    'DOP': 'RD$',
    'HTG': 'G',
    'JMD': 'J$',
    'KYD': 'CI$',
    'BSD': 'B$',
    'BBD': 'Bds$',
    'XCD': 'EC$',
    'TTD': 'TT$',
    'AWG': 'ƒ',
    'ANG': 'ƒ',
    'FJD': 'FJ$',
    'PGK': 'K',
    'SBD': 'SI$',
    'VUV': 'VT',
    'WST': 'WS$',
    'TOP': 'T$',
    'TVD': '$',
    'KID': '$',
    'BTC': '₿',
    'ETH': 'Ξ',
    'LTC': 'Ł',
    'XRP': 'XRP',
    'ADA': '₳',
    'DOT': '●',
    'BCH': '₿',
    'BNB': 'BNB',
    'SOL': '◎',
    'AVAX': 'AVAX',
    'MATIC': 'MATIC',
    'UNI': 'UNI',
    'LINK': 'LINK',
    'ATOM': 'ATOM',
    'XLM': '*',
    'VET': 'VET',
    'ICP': '∞',
    'FIL': '⨎',
    'TRX': 'TRX',
    'ETC': 'ETC',
    'XMR': 'ɱ',
    'ALGO': 'ALGO',
    'HBAR': 'ℏ',
    'EGLD': 'eGLD',
    'NEAR': 'Ⓝ',
    'FLOW': 'FLOW',
    'APE': 'APE',
    'SAND': 'SAND',
    'MANA': 'MANA',
    'CRO': 'CRO',
    'LRC': 'LRC',
    'USDT': '$',
    'USDC': '$',
    'BUSD': '$',
    'DAI': '$',
    'TUSD': '$',
    'USDP': '$',
    'FRAX': '$',
    'LUSD': '$',
    'USDD': '$',
    'EURT': '€',
    'XAU': 'Au',
    'XAG': 'Ag',
    'XPT': 'Pt',
    'XPD': 'Pd',
    'DEM': 'DM',
    'FRF': '₣',
    'ITL': '₤',
    'ESP': '₧',
    'NLG': 'ƒ',
    'BEF': '₣',
    'ATS': 'S',
    'FIM': 'mk',
    'IEP': '£',
    'PTE': '$',
    'GRD': '₯',
}

export default function useCurrency() {
    return {
        currencySymbols,
    }
}
